export function getUSHolidays(year: number = new Date().getFullYear()) {
  return [
    {
      name: "New Year's Day",
      date: `${year}-01-01`,
      emoji: '🎉',
      category: 'Holiday' as const,
      color: 'blue' as const,
    },
    {
      name: "Valentine's Day",
      date: `${year}-02-14`,
      emoji: '💕',
      category: 'Holiday' as const,
      color: 'pink' as const,
    },
    {
      name: "St. Patrick's Day",
      date: `${year}-03-17`,
      emoji: '☘️',
      category: 'Holiday' as const,
      color: 'green' as const,
    },
    {
      name: 'Easter',
      date: `${year}-04-05`,
      emoji: '🐰',
      category: 'Holiday' as const,
      color: 'purple' as const,
    },
    {
      name: 'Memorial Day',
      date: `${year}-05-25`,
      emoji: '🇺🇸',
      category: 'Holiday' as const,
      color: 'red' as const,
    },
    {
      name: 'Independence Day',
      date: `${year}-07-04`,
      emoji: '🎆',
      category: 'Holiday' as const,
      color: 'red' as const,
    },
    {
      name: 'Labor Day',
      date: `${year}-09-07`,
      emoji: '🔧',
      category: 'Holiday' as const,
      color: 'blue' as const,
    },
    {
      name: 'Halloween',
      date: `${year}-10-31`,
      emoji: '🎃',
      category: 'Holiday' as const,
      color: 'orange' as const,
    },
    {
      name: 'Thanksgiving',
      date: `${year}-11-26`,
      emoji: '🦃',
      category: 'Holiday' as const,
      color: 'gold' as const,
    },
    {
      name: 'Christmas',
      date: `${year}-12-25`,
      emoji: '🎄',
      category: 'Holiday' as const,
      color: 'green' as const,
      is_recurring: true,
    },
    {
      name: "New Year's Eve",
      date: `${year}-12-31`,
      emoji: '🥳',
      category: 'Holiday' as const,
      color: 'gold' as const,
    },
  ];
}

export const US_HOLIDAYS = getUSHolidays(2026);